import { Or } from "source/app/domain/Or";
import { IChevronPanelStyleOptions } from "./IChevronPanelStyleOptions";
import { IChevronPanelState } from "../IChevronPanelState";

export const GetChevronPanelStyle = (options: IChevronPanelStyleOptions) => {
    const width = !options.state.isOpen ? "100%" : options.style?.width;
    const opacity = GetOpacity(options);
    const background =
        "linear-gradient(to right, rgba(0, 0, 0, 0), #00000026, rgba(0, 0, 0, 0))";

    if (options.style) {
        return {
            ...options.style,
            width,
            opacity,
            background,
        };
    }

    return {
        opacity,
        background,
    };
};

const GetOpacity = (options: IChevronPanelStyleOptions) => {
    const isDynamicOpacityEnabled = Or(options.dynamicOpacity, true);

    if (!isDynamicOpacityEnabled) {
        return 1;
    }

    return options.isOpen ? 1.0 : 0.3;
};
